<template>
    <div class="knockoutBracket">
        <template v-for="(event, index) in knockoutEvent">
            <KnockoutTbdEvent
                v-if="event.status === KnockoutEventStatus.Tbd"
                v-bind:key="`${index}-tbd`"
                v-bind:event="event"
            />
            <KnockoutRunningEvent
                v-else-if="event.status === KnockoutEventStatus.Running && event.runningEvent"
                v-bind:key="`${event.runningEvent.id}-running`"
                v-bind:runningEvent="event.runningEvent"
            />
            <KnockoutCloseEvent
                v-else-if="event.status === KnockoutEventStatus.Closed"
                v-bind:key="`${index}-closed`"
                v-bind:event="event"
            />
            <KnockoutEndedEvent
                v-else
                v-bind:key="`${index}-end`"
                v-bind:event="event"
            />
        </template>
    </div>
</template>

<script lang="ts" setup>
    import KnockoutCloseEvent from '@/components/tournamentCenter/knockout/KnockoutCloseEvent.vue';
    import KnockoutEndedEvent from '@/components/tournamentCenter/knockout/KnockoutEndedEvent.vue';
    import KnockoutRunningEvent from '@/components/tournamentCenter/knockout/KnockoutRunningEvent.vue';
    import KnockoutTbdEvent from '@/components/tournamentCenter/knockout/KnockoutTbdEvent.vue';
    import type { IKnockoutEvent } from '@/interface/tournamentCenter';
    import { KnockoutEventStatus } from '@/interface/tournamentCenter';

    defineProps<{
        knockoutEvent: IKnockoutEvent[];
    }>();
</script>

<style lang="scss" scoped>
    @import "@/components/tournamentCenter/KnockoutBracket";
</style>
